import { mapState, mapMutations } from 'vuex';
import { validationFormMixin } from '../../../shared/mixins/validationFormMixin';
import {
  fetchExtracurricularActivity,
  createExtracurricularActivity,
  updateExtracurricularActivity,
  deleteExtracurricularActivity,
} from '../../helpers/KnGroupsOptions';
import KnFormSubtitle from '../../../shared/components/KnFormSubtitle/KnFormSubtitle.vue';
import KnFormActionButtons from '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue';
import KnPagination from '../../../shared/components/KnPagination.vue';
import { paginationMixin } from '@/modules/shared/mixins/paginationMixin';

export default {
  components: {
    KnFormSubtitle,
    KnFormActionButtons,
    KnPagination,
  },
  mixins: [paginationMixin, validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      extracurricularActivity: {
        id: 'NA', // No asignado
        nombre: null,
        descripcion: null,
        fecha_inicio: null,
        fecha_fin: null,
        id_institucion_educativa: null,
      },
      extracurricularActivitys: [],
      toUpdate: false,
      showInactive: false,
      loading: false,
    };
  },
  computed: {
    ...mapState(['institutionId']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear';
    },
    invalidFields() {
      return this.objectHasNulls(this.extracurricularActivity);
    },
  },
  async created() {
    this.setIsLogin(false);
    await this.getPaginateExtracurricularActivity(1);
    this.extracurricularActivity.id_institucion_educativa = this.institutionId;
  },
  watch: {
    showInactive: {
      async handler() {
        await this.getPaginateExtracurricularActivity(1);
      },
    },
    institutionId: {
      async handler() {
        this.setIsLogin(false);
        await this.getPaginateExtracurricularActivity(1);
        this.extracurricularActivity.id_institucion_educativa =
          this.institutionId;
      },
    },
  },
  methods: {
    ...mapMutations(['setIsLogin']),
    async getPaginateExtracurricularActivity(page = 1) {
      try {
        this.extracurricularActivitys = [];
        this.setPaginationPage(page);

        if (!this.loading) {
          this.loading = true;

          const { ok, data, message, count } =
            await fetchExtracurricularActivity({
              institutionId: this.institutionId,
              systemStatus: !this.showInactive,
              limit: this.pagination.limit,
              offset: this.pagination.offset,
            });

          if (ok) {
            this.setPaginationCount(count);
            for (const extracurricularActivitys of data) {
              this.extracurricularActivitys.push({
                ...extracurricularActivitys,
              });
            }
          } else {
            console.error(
              'No se pudieron obtener las actividades extraescolares',
              message
            );
          }
          this.loading = false;
        }
      } catch (error) {
        console.error(
          'Error al obtener las actividades extraescolares:',
          error
        );
        this.loading = false;
      }
    },

    async save() {
      if (this.toUpdate) {
        await updateExtracurricularActivity(
          this.extracurricularActivity.id,
          this.extracurricularActivity.nombre,
          this.extracurricularActivity.descripcion,
          this.extracurricularActivity.fecha_inicio,
          this.extracurricularActivity.fecha_fin,
          this.institutionId
        );
        this.toUpdate = false;
        await this.getPaginateExtracurricularActivity(1);
      } else {
        await createExtracurricularActivity(
          this.extracurricularActivity.nombre,
          this.extracurricularActivity.descripcion,
          this.extracurricularActivity.fecha_inicio,
          this.extracurricularActivity.fecha_fin,
          this.institutionId
        );
        this.clear();
        await this.getPaginateExtracurricularActivity(1);
      }
      this.clear();
    },
    clear() {
      this.extracurricularActivity = {
        id: 'NA', // No asignado
        nombre: null,
        descripcion: null,
        fecha_inicio: null,
        fecha_fin: null,
        id_institucion_educativa: null,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    clearInline() {
      this.extracurricularActivity = {
        id: 'NA', // No asignado
        nombre: null,
        descripcion: null,
        fecha_inicio: null,
        fecha_fin: null,
        id_institucion_educativa: null,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    edit(item) {
      this.extracurricularActivity = { ...item };
      // console.log("Item a editar:", this.evaluationTypes);
      this.toUpdate = true;
    },
    async deleteInline(itemId) {
      await deleteExtracurricularActivity(itemId);
      await this.getPaginateExtracurricularActivity(1);
      this.clearInline();
    },
  },
};
